import toast from "react-hot-toast";
import { axiosInstance } from "../components/lib/axios";


export const fetchContactInfoData = async () => {
    try {
        const res = await axiosInstance.get(`/contact`)
        // toast.success("Successfully fetched!");
        return res.data.data
        // console.log("lorem")

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}


export const postQueryRequest = async (formData) => {
    try {

        const res = await axiosInstance.post(
            `/query`,
            formData,
        );
        toast.success("Successfully Registered!");
        return res.data?.data;
    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}